import { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { IconCheck } from "../../../../icons";
import IconButton from "../../../../components/IconButton";
import Button from "../../../../components/Button";
import { sendEmailValidate } from "../../service/index";
import "./index.scss";
import toast, { Toaster } from "react-hot-toast";
import { toastSuccess } from "../../../../components/Toast";

type TypePage = "created" | "welcome";

export const SuccessSignUp = ({ value }) => {
  const [time, setTime] = useState(120);
  const [page, setPage] = useState<TypePage>("created");
  const [email, setEmail] = useState<any>();
  const history = useHistory();

  useEffect(() => {
    setTimeout(() => {
      if (time > 0) setTime((oldTime) => oldTime - 1);
      if (!time) history.push("/login");
    }, 1000);
  }, [time]);

  const hours = String(Math.floor(time / 60))?.padStart(2, "0");
  const minutes = String(time % 60)?.padStart(2, "0");

  async function resendEmailValidate() {
    const resend = await sendEmailValidate(value.email);
    if (resend?.ok) toastSuccess("E-mail enviado novamente!");
  }

  return (
    <>
      <Toaster position="top-left" />
      {page === "created" && (
        <>
          <div className="flex flex-col justify-center items-center w-full h-screen">
            <div className="progress-redirect bg-blue-100 text-primary font-familyPoppins text-sm px-2 py-1 rounded-xl ">
              <p>
                Você será redirecionado em{" "}
                <span className="text-base font-semibold -mb-2">
                  {hours}:{minutes}
                </span>
              </p>
            </div>
            <div className="flex flex-col items-center w-3/5 sm:w-4/5">
              <IconButton icon={IconCheck} className="icon-createdCorp box-icon-checked" />
              <div className="flex justify-center items-center"></div>
              <div className="box-pulse-created flex justify-center items-center"></div>
              <h1 className="text-5xl font-semibold text-center">Dados enviados com sucesso</h1>
              <span className="text-1.6rem mt-5 text-textPrimary text-center">
                <span className="m-4">
                  Recebemos seus dados. Enviamos um e-mail para <span className="text-primary">{value.email}</span> com um link para validar sua
                  conta.
                </span>
                <p>Após a validação você poderá acessar seu ambiente e começar a aproveitar todos os recursos Integra Admin disponíveis.</p>
              </span>
            </div>
            <div className="flex flex-col w-full gap-6 px-4 my-10">
              <div className="w-full flex justify-center">
                <Link to="/login" className="w-3/5 sm:w-4/5 h-full">
                  <Button className="w-full text-primary bg-blue-50 hover:bg-gray-100 rounded-xl">Voltar para Login</Button>
                </Link>
              </div>
              <p className="w-full flex justify-center text-xl text-textPrimary mt-3">
                Você não recebeu e-mail?{" "}
                <span className="text-primary font-bold ml-2 cursor-pointer" onClick={resendEmailValidate}>
                  Tente novamente
                </span>
              </p>
            </div>
          </div>
          <div className="px-20 mb-10">
            <p className="w-full text-center text-xl text-textPrimary">
              O e-mail pode demorar alguns minutos para aparecer na sua caixa de entrada. Certifique-se de olhar na sua caixa de Spam. Você também
              pode entrar em contato se encontrar alguma dificuldade.
            </p>
          </div>
        </>
      )}
    </>
  );
};
